import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
  TypedUseSelectorHook,
} from 'react-redux';
import exportDataAsCsvReducer from './export-data-as-csv';
import CustomizerReducer from './customizer/CustomizerSlice';
import EcommerceReducer from './apps/eCommerce/ECommerceSlice';

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    exportDataAsCsv: exportDataAsCsvReducer,
    ecommerceReducer: EcommerceReducer,
  },
});

const rootReducer = combineReducers({
  exportDataAsCsv: exportDataAsCsvReducer,
  customizer: CustomizerReducer,
  ecommerceReducer: EcommerceReducer,
});

export type AppState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const { dispatch } = store;
export const useDispatch = () => useAppDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<AppState> = useAppSelector;
